import styled from 'styled-components';
import { FONTS, SIZE, COLORS } from '@app/src/ui';
import { withShimmer } from '@app/src/common/withShimmer';

interface Props {
  isBold?: boolean;
  width?: number;
  height?: number;
  position?: string;
}

export const Wrapper = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  margin: 20px 0;
`;

Wrapper.displayName = 'Wrapper';

export const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 7px 0 20px;

  @media(min-width: ${SIZE.TABLET_BREAK}) {
    margin: 20px 0;
  }
`;

Box.displayName = 'Box';

export const Preview = styled.div`
  width: 100%;
  margin-bottom: 7px;

  @media(min-width: ${SIZE.TABLET_BREAK}) {
    width: 240px;
    margin: 0;
    padding-right: 26px;
  }
`;

Preview.displayName = 'Preview';

export const TextBox = styled.div`
  padding: 4px 9px;
  box-sizing: border-box;
  border: 1px solid ${COLORS.GRAY_PLACEHOLDER};
  color: #000000;
  text-align: justify;
`;

TextBox.displayName = 'TextBox';

export const Text = styled.span`
  font-size: 13px;
  font-weight: ${(props: Props) =>
    props.isBold && 'bold'};
`;

Text.displayName = 'Text';

export const Summary = styled.div`
  width: 100%;

  @media(min-width: ${SIZE.TABLET_BREAK}) {
    width: calc(100% - 240px);
  }
`;

Summary.displayName = 'Summary';

export const SummaryDescription = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  font-size: 12px;
  margin: 2px 0;
`;

SummaryDescription.displayName = 'SummaryDescription';

const POSITION = {
  left: 'flex-start',
  right: 'flex-end'
}

export const TextDescription = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 50%;
  height: 12px;
  justify-content: ${(props: Props) => props.position
    && POSITION[props.position]};
`;

TextDescription.displayName = 'TextDescription';

export const Line = styled.div`
  width: 100%;
  background-color: ${COLORS.GRAY_LIGHT};
  height: 1px;
  margin: 4px 0;
`;

Line.displayName = 'Line';

export const Shimmer = withShimmer()(styled.div``);

Shimmer.displayName = 'Shimmer';

export const Rectangle = styled.div`
  margin: 4px 0;
  height: ${(props: Props) => props.height
    ? `${props.height}px`
    : '10px'};
  width: ${(props: Props) => props.width
    ? `${props.width}%`
    : '100%'};
`;

Rectangle.displayName = 'Rectangle';